export default function displayURLForFund(
    type: "pmc" | "collective" | "etf",
    cardVariant?: string,
) {
    return type !== "pmc" || cardVariant === "Normal PMC Fund card";
}
